import React, { useEffect, useState } from 'react';
import { validateEnablePayCapital } from '../../payment/PaidUpCapital';
import { getCapitalLisSingle } from '../../../actions/capital';
import CurrencyFormat from '../../../components/currencyFormat/currencyFormat';

const PriceDisplay = ({ message }) => {
    const [price, setPrice] = useState(null);

    useEffect(() => {
        const fetchPrice = async () => {
            if (!message?.data?.company) return;

            try {
                const resp = await getCapitalLisSingle(message.data.company);
                const result = parseFloat(
                    validateEnablePayCapital(
                        message.data,
                        resp?.paidUpAmountPaid,
                        true
                    )
                );
                setPrice(result);
            } catch (error) {
                console.error("Failed to fetch price:", error);
            }
        };

        fetchPrice();
    }, [message]);

    if (price === null) return <span>Loading...</span>;

    return (
        <CurrencyFormat
            currency={message?.data?.currency?.toLowerCase()}
            value={price}
            decimal={2}
        />
    );
};

export default PriceDisplay;
